import { render, staticRenderFns } from "./orderEdit.vue?vue&type=template&id=57dd3d8f&"
import script from "./orderEdit.vue?vue&type=script&lang=js&"
export * from "./orderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports